var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagramSocials(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_234_335)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.6259 17.2149C29.402 9.68972 24.7414 2.14949 17.2162 0.373377C9.69097 -1.40274 2.15075 3.25784 0.374632 10.7831C-1.40148 18.3083 3.25909 25.8485 10.7843 27.6246C18.3095 29.4007 25.8498 24.7402 27.6259 17.2149Z",
    fill: "#F77962"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_234_335)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 16C15.1046 16 16 15.1046 16 14C16 12.8954 15.1046 12 14 12C12.8954 12 12 12.8954 12 14C12 15.1046 12.8954 16 14 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3982 8H10.6017C9.16485 8 8 9.16485 8 10.6017V17.3982C8 18.8352 9.16485 19.9999 10.6017 19.9999H17.3982C18.8352 19.9999 19.9999 18.8351 19.9999 17.3982V10.6017C20 9.16485 18.8352 8 17.3982 8ZM14.0139 17.2503C12.2499 17.2503 10.8149 15.8152 10.8149 14.0512C10.8149 12.2873 12.2499 10.8522 14.0139 10.8522C15.7779 10.8522 17.2129 12.2873 17.2129 14.0512C17.2129 15.8152 15.7779 17.2503 14.0139 17.2503ZM17.3333 11.2576C16.9668 11.2576 16.6696 10.9604 16.6696 10.5938C16.6696 10.2273 16.9668 9.9301 17.3333 9.9301C17.6999 9.9301 17.9971 10.2273 17.9971 10.5938C17.9971 10.9604 17.6999 11.2576 17.3333 11.2576Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_234_335"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_234_335"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramSocials);
export default __webpack_public_path__ + "static/media/instagram-socials.17bee8539bd8f5b49687b2cd1c51052b.svg";
export { ForwardRef as ReactComponent };